import type { Award, AwardCategory } from "@/lib/conditions/awards-types";
import { AwardCard } from "./AwardCard";

const CATEGORY_ORDER: AwardCategory[] = [
  "headline",
  "controversial",
  "fun",
  "data-nerd",
];

const CATEGORY_TITLES: Record<AwardCategory, { title: string; subtitle: string }> = {
  headline: {
    title: "The Headline Awards",
    subtitle: "The biggest prizes. Earned with data.",
  },
  controversial: {
    title: "The Controversial Awards",
    subtitle: "Not everyone will be happy about these.",
  },
  fun: {
    title: "The Fun Awards",
    subtitle: "Deep cuts, patterns, and things nobody asked for.",
  },
  "data-nerd": {
    title: "The Data Nerd Awards",
    subtitle: "For the spreadsheet-curious.",
  },
};

export function AwardsList({ awards }: { awards: Award[] }) {
  const grouped = new Map<AwardCategory, Award[]>();
  for (const award of awards) {
    const list = grouped.get(award.category) ?? [];
    list.push(award);
    grouped.set(award.category, list);
  }

  return (
    <div className="space-y-16 md:space-y-24">
      {CATEGORY_ORDER.map((cat) => {
        const section = CATEGORY_TITLES[cat];
        const categoryAwards = grouped.get(cat);
        return (
          <section key={cat}>
            <div className="mb-8 md:mb-12">
              <h2 className="font-serif text-[28px] md:text-[40px] font-bold text-navy leading-[1.08] tracking-[-0.015em] mb-2">
                {section.title}
              </h2>
              <p className="text-[14px] md:text-[16px] text-text-muted leading-[1.6]">
                {section.subtitle}
              </p>
            </div>
            {categoryAwards?.length ? (
              <div className="space-y-8 md:space-y-12">
                {categoryAwards.map((award) => (
                  <AwardCard key={award.id} award={award} />
                ))}
              </div>
            ) : (
              <div className="rounded-[18px] border border-border-light bg-white/60 px-6 py-8 text-center">
                <p className="text-[14px] text-text-muted">
                  Awaiting first award. Not enough scored data in this category yet.
                </p>
              </div>
            )}
          </section>
        );
      })}
    </div>
  );
}
